<template>
    <div class="view-account">
        <el-button
            :disabled="buttonDisabled"
            @click.stop="dialogFormVisible = true"
            v-if="showViewBtn"
        >
            验证查看
        </el-button>
        <el-dialog
            width="300px"
            :modal="false"
            :visible.sync="dialogFormVisible"
            @close="resetForm"
        >
            <p class="view-account__title" slot="title">请输入验证码</p>
            <el-form
                :rules="rules"
                ref="ruleForm"
                :model="form"
                class="view-account__form"
            >
                <el-form-item class="view-account__item">
                    <div class="view-account__item-cn">
                        <img
                            :src="verifyCode"
                            class="verify"
                            width="110"
                            height="40"
                            style="float: left;background-color: rgb(209, 209, 209)"
                            @click="getVerifyCode()"
                        >
                        <i @click="getVerifyCode()"
                           style="cursor:pointer;display:inline-block;font-size: 30px;margin-left: 20px"
                           class="el-icon-refresh-left"></i>
                    </div>
                </el-form-item>
                <el-form-item prop="verifyCode" class="view-account__item">
                    <el-input
                        v-model="form.verifyCode"
                        autocomplete="off"
                        @change="() => {
                          this.errorCode = ''
                        }"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="view-account__footer">
                <el-button :loading="loading" @click="submitForm" type="primary">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import qs from 'qs'
import { validCode, getAgentRealAccount, getMerchantRealAccount } from '@/api/global'
export default {
  props: {
    agentId: {
      default: ''
    },
    merchantId: {
      default: ''
    },
    isReset: {
      type: Boolean,
      required: true
    },
    showViewBtn: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      dialogFormVisible: false,
      buttonDisabled: false,
      form: {
        verifyCode: ''
      },
      formLabelWidth: '120px',
      verifyCode: '',
      rules: {
        verifyCode: [
          { validator: this.validateverifyCode, trigger: 'blur' }
        ]
      },
      loading: false,
      errorCode: ''
    }
  },
  watch: {
    dialogFormVisible () {
      if (this.dialogFormVisible) {
        this.getVerifyCode()
      }
    },
    isReset () {
      if (this.isReset) {
        this.buttonDisabled = false
      }
    }
  },
  methods: {
    validateverifyCode (rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (this.errorCode) {
        callback(new Error('验证码错误，请重新输入'))
      } else {
        callback()
      }
    },
    getVerifyCode () {
      let data = {}
      data = qs.stringify(data)
      validCode(data).then((data) => {
        if (data.error_code) {
          this.verifyCode = data.verifyCodeUrl
        }
      })
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.agentId) {
            this.getAgentRealAccount()
          } else {
            this.getMerchantRealAccount()
          }
        } else {
          this.getVerifyCode()
        }
      })
    },
    getAgentRealAccount () {
      const data = {
        verifyCode: this.form.verifyCode,
        agentId: this.agentId
      }
      this.loading = true
      getAgentRealAccount(data).then((data) => {
        if (data.error_code === '-1002') {
          this.errorCode = data.error_msg
          this.submitForm()
        } else if (data.error_code === '0') {
          this.$emit('success', data.agentInfo)
          this.dialogFormVisible = false
          this.buttonDisabled = true
        } else {
          this.$message.error('查看失败')
        }
        this.loading = false
      })
    },
    getMerchantRealAccount () {
      const data = {
        verifyCode: this.form.verifyCode,
        merchantId: this.merchantId
      }
      this.loading = true
      getMerchantRealAccount(data).then((data) => {
        if (data.error_code === '-1002') {
          this.errorCode = data.error_msg
          this.submitForm()
        } else if (data.error_code === '0') {
          this.$emit('success', data.merchant)
          this.dialogFormVisible = false
          this.buttonDisabled = true
        } else {
          this.$message.error('查看失败')
        }
        this.loading = false
      })
    },
    resetForm () {
      this.errorCode = ''
      this.$refs.ruleForm.resetFields()
    }
  },
  mounted () {
    this.getVerifyCode()
  }
}
</script>
<style rel="stylesheet/scss" lang="scss">
    .view-account {
        display: inline-block;
        &__title {
            text-align: center;
        }
        &__footer {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &__item-cn {
            display: flex;
            align-items: center;
        }
        &__item.el-form-item {
            width: 70%;
            margin: 0 auto 22px;
        }
        .el-dialog__body {
            padding: 0;
        }
    }
</style>
